<template>
  <div class="footer">
    <div class="foo-top">
      <div class="left">
        <div class="foo-toplogo"></div>
        <div class="foo-message f18fff18">
          <div style="padding-right: 100px">
            <div style="opacity: 0.6">办公地址</div>
            <div>北京朝阳区望京街道望京SOHO T1C座1012</div>
          </div>
          <div>
            <div style="opacity: 0.6">电子邮箱</div>
            <div>info@engglobal.info</div>
          </div>
        </div>
        <div class="foo-icon">
          <img src="@/assets/pc/footer-contact1.png" alt="" />
          <img src="@/assets/pc/footer-contact2.png" alt="" />
        </div>
      </div>
      <div class="right">
        <div class="slogon f18fff18">
          <div>梦想无限 I 共创和谐未来</div>
          <div>Boundless dreams I harmonious future</div>
        </div>
        <div class="f18fff18">
          <template v-for="(nav, key) in navList">
            <router-link v-if="nav.id != 6" :to="`${nav.link}`" class="f16fff">{{nav.name}}</router-link>
          </template>
        </div>
      </div>
    </div>
    <div class="foo-bott f14fff">© 2024 Elite Circle Global 保留所有权利</div>
  </div>
</template>
<script>
import { GetNav } from "@/api/api";
export default {
  name: "FooterView",
  data() {
    return {
      navList: [],
    };
  },
  created() {
    GetNav().then((res) => {
      if (res.data.code == 1) {
        this.navList = res.data.data;
        // localStorage.setItem('navList',JSON.stringify(this.navList))
      }
    });
  },
};
</script>
<style scoped>
.footer {
  width: 100%;
  background: url(@/assets/pc/footer-bg.png) no-repeat;
  background-size: 140%;
  background-position: center;
  padding: 0 8.33vw;
}
.foo-top {
  display: flex;
  justify-content: space-between;
  padding: 80px 0 60px 0;
}
.foo-toplogo {
  width: 188px;
  height: 84px;
  background: url(@/assets/pc/footer-logo.png) no-repeat;
  background-size: cover;
  background-position: left;
}
.foo-top .left .foo-message {
  padding: 60px 0;
  display: flex;
}
.foo-top .left .foo-message > div > div:first-of-type {
  padding-bottom: 20px;
}
.foo-top .left .foo-icon img {
  margin-right: 20px;
  width: 32px;
  height: 32px;
}
.foo-top .right {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
}
.foo-top .right .slogon.f18fff18 {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.foo-top .right .slogon.f18fff18 > div:first-of-type {
  padding-bottom: 10px;
}
.foo-top .right .f18fff18 {
  padding-bottom: 10px;
}
.foo-top .right .f18fff18 > a {
  padding-right: 40px;
}
.foo-top .right .f18fff18 > a:last-of-type {
  padding-right: 0px;
}
.foo-bott {
  width: 100%;
  /* height: 140px; */
  border-top: 1px solid #6a6c7c;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  opacity: 0.7;
}
</style>
